<template>
  <div class="player">
  </div>
</template>

<script>
import howlerMixin from '@/utils/howlerMixin'
import EventBus from '@/utils/eventBus'
export default {
  mixins: [
    howlerMixin
  ],
  // 'progress' is emitted by this component's own `watch` block below (not part of the
  // mixin's Howl-event emits) — see MenuItem.vue's comment for why this needs declaring.
  emits: ['progress'],
  created () {
    EventBus.on('play', this.togglePlayback)
    EventBus.on('stop', this.stop)
  },
  beforeUnmount () {
    EventBus.off('play', this.togglePlayback)
    EventBus.off('stop', this.stop)
  },
  computed: {
    playIcon () {
      return this.playing ? 'icon-pause' : 'icon-play'
    }
  },
  watch: {
    progress (val) {
      this.$emit('progress', val)
    },
    playing (val) {
      if (val) {
        this.$emit('play')
      } else {
        this.$emit('stop')
      }
    }
  }
}
</script>

<style>

</style>
